import styled from './Title.module.css';



const Title = () => {


    return(

        <div className={styled.containerTitle}>
        <h1 className={styled.title}>
         Preparacion pintura automotriz en sistemas y acrilicos
        </h1>
        </div>
    )


}


export default Title;